import { render, staticRenderFns } from "./position-manage.vue?vue&type=template&id=2271fe8d&scoped=true"
import script from "./position-manage.vue?vue&type=script&lang=js"
export * from "./position-manage.vue?vue&type=script&lang=js"
import style0 from "./position-manage.vue?vue&type=style&index=0&id=2271fe8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2271fe8d",
  null
  
)

export default component.exports